import { menuInsert } from "./menu.js";


const BROWSER_SMALL_SCREEN = 480;
let _browserIsMobile = "none";

function browserGetBrowserWidth() {
  return document.body.clientWidth; // window.innerWidth ||
}

function browserGetBrowserHeight() {
  return window.innerHeight || document.body.clientHeight; //  ||
}

// Cookies ---------------------------------------------------------------------

function browserSetCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function browserGetCookie(cname) {
  const name = cname + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// rendering

function browserAfterRendering(action) {
  requestAnimationFrame(() => {
    setTimeout(() => {
      action();
    });
  });
}

// images ----------------------------------------------------------------------

function browserImageIsReady(image) {
  return new Promise((resolve, reject) => {
    //
    if (image.complete) {
      resolve();
    } else {
      image.addEventListener("load", (e) => {
        resolve();
      });
      image.addEventListener("error", () => {
        reject(new Error(`Failed to load image's URL: ${image}`));
      });
    }
  });
}

// menu ------------------------------------------------------------------------

function browserMenuToggleInit(buttonId, menuId, classToggle, closeMenuId) {
  menuInsert();

  const button = document.getElementById(buttonId);
  const close = document.getElementById(closeMenuId);
  const menu = document.getElementById(menuId);

  if (button !== null && menu !== null && close !== null) {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      menu.classList.toggle(classToggle);
    });

    close.addEventListener("click", (event) => {
      event.preventDefault();
      menu.classList.toggle(classToggle);
    });
    document.addEventListener("click", (event) => {
      if (!menu.classList.contains(classToggle)) {
        const isClickInsideMenu = menu.contains(event.target);
        const isClickInsideButton = button.contains(event.target);
        const isClickInsideClose = close.contains(event.target);

        if (!isClickInsideMenu && !isClickInsideButton && !isClickInsideClose) {
          menu.classList.add(classToggle);
        }
      }
    });
  }
}

function browserIsSmallScreen()
{
    if (browserGetBrowserWidth() < BROWSER_SMALL_SCREEN)
    {
        return true;
    }
    else
    {
        return (false);
    }
}

// mobile ----------------------------------------------------------------------
function browserIsMobile() {
  if (_browserIsMobile === "none") {
    if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
      _browserIsMobile = true;
    } else {
      _browserIsMobile = false;
    }
  }
  return _browserIsMobile;
}

// sharing ---------------------------------------------------------------------
function browserCanShare() {
  return !!navigator.share;
}

function browserShare(urlString) {
  navigator
    .share({
      url: urlString
    })
    .then(() => console.log("Share was successful."))
    .catch((error) => console.log("Sharing failed", error));
}

// ------------------------------------------------------------------------------
function onBrowserTooltip(event) {
  if (browserGetBrowserWidth() < 480) {
    const target = event.target;
    const tooltipText = target.getElementsByClassName("posterTooltiptext");
    const marginLeft =
      -target.getBoundingClientRect().left +
      (browserGetBrowserWidth() - 280) / 2;
    tooltipText[0].style.marginLeft = marginLeft + "px";
  }
}

// -----------------------------------------------------------------------------

export {
  BROWSER_SMALL_SCREEN,
  browserGetBrowserWidth,
  browserGetBrowserHeight,
  browserSetCookie,
  browserGetCookie,
  browserAfterRendering,
  browserImageIsReady,
  browserMenuToggleInit,
  browserIsSmallScreen,
  browserIsMobile,
  browserCanShare,
  browserShare,
  onBrowserTooltip
};
